/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Dutch
export default {
  'fabric.atlassianSwitcher.switchTo': 'Overschakelen naar',
  'fabric.atlassianSwitcher.switchToTooltip': 'Overschakelen naar...',
  'fabric.atlassianSwitcher.recent': 'Recent',
  'fabric.atlassianSwitcher.more': 'Meer',
  'fabric.atlassianSwitcher.try': 'Uitproberen',
  'fabric.atlassianSwitcher.manageList': 'Lijst beheren',
  'fabric.atlassianSwitcher.jiraProject': 'Jira-project',
  'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-space',
  'fabric.atlassianSwitcher.people': 'Gebruikers',
  'fabric.atlassianSwitcher.administration': 'Beheer',
  'fabric.atlassianSwitcher.discoverMore': 'Meer ontdekken',
  'fabric.atlassianSwitcher.errorHeading': 'Er is iets misgegaan',
  'fabric.atlassianSwitcher.errorText': 'We houden deze fouten bij, maar aarzel niet om contact met ons op te nemen als de pagina vernieuwen het probleem niet oplost.',
  'fabric.atlassianSwitcher.errorImageAltText': 'Een defecte robot en een aantal mensen die bezig zijn hem te repareren.',
  'fabric.atlassianSwitcher.expand': 'Meer weergeven'
};